<template>
  <div class="appointment-card" v-if="skeleton || appointment">
    <UiModal
      v-if="!(skeleton) && cancelModal && appointment"
      @close="cancelModal = false"
      @confirm="confirmCancel"

      :title="`Anulare programare`"
      :subtitle="`${ timeDate } | ${ appointment[role][0].full_name }`"

      :buttons="[
        {
          event: 'confirm',
          style: 'danger',
          text: 'Confirm anularea'
        }, {
          event: 'close',
          text: 'Renunță'
        }
      ]"
    >
      <template v-slot:body>
        <h4 class="appointment-card__warning">
          Ești sigur că dorești să anulezi această programare?
        </h4>
      </template>
    </UiModal>

    <TemplateCard
      v-if="skeleton"

      :appearance="appearance"
      :skeleton="skeleton"
    />

    <TemplateCard
      v-else-if="status === 'ended' || appointment.status == 'ended' || appointment.status == 'canceled'"
      @clickAction="meetingJoin"

      :appearance="appearance"
      :highlight="false"

      :cardActionType="(appointment.status == 'canceled') ? 'danger' : 'primary'"
      :cardActionValue="timeDateTime"
      cardSubActionType="gray"
      :cardSubActionValue="(appointment.status == 'canceled') ? 'Programare anulată' : 'Ședința s-a terminat'"

      :cardList="[
        { 
            icon: (appointment.status == 'canceled') ? 'fa-exclamation-circle' : 'fa-clock', 
            title: (appointment.status == 'canceled') ? 'Status' : 'Durată programare', 
            value: timeDuration 
        },
        { 
            icon: 'fa-calendar',
            title: 'Data',
            value: timeDate
        }
      ]"

      :specialistId="role === 'specialist' ? appointment.specialist_id : null"
      :spacialistName="appointment[role][0].full_name"
      :specialistTitle="role === 'specialist' ? appointment[role][0].title : 'Client'"
      :specialistAvatar="appointment[role][0].image_url"
    />

    <TemplateCard
      v-else-if="status === 'processing'"

      :appearance="appearance"
      :highlight="false"

      cardActionType="processing"
      cardActionValue="Intră în ședință"
      cardSubActionType="gray"
      cardSubActionValue="Camera ședinței se generează"

      :cardList="[
        { icon: 'fa-clock'   , title: 'Durată programare', value: timeDuration },
        { icon: 'fa-calendar', title: 'Data'             , value: timeDate }
      ]"

      :specialistId="role === 'specialist' ? appointment.specialist_id : null"
      :spacialistName="appointment[role][0].full_name"
      :specialistTitle="role === 'specialist' ? appointment[role][0].title : 'Client'"
      :specialistAvatar="appointment[role][0].image_url"
    />

    <TemplateCard
      v-else-if="status === 'started'"
      @clickAction="meetingJoin"

      :appearance="appearance"
      :highlight="true"

      cardActionType="secondary"
      cardActionValue="Intră în ședință"
      cardSubActionType="gray"
      cardSubActionValue="Ședința a început"

      :cardList="[
        { icon: 'fa-clock'   , title: 'Durată programare', value: timeDuration },
        { icon: 'fa-calendar', title: 'Data'             , value: timeDate }
      ]"

      :specialistId="role === 'specialist' ? appointment.specialist_id : null"
      :spacialistName="appointment[role][0].full_name"
      :specialistTitle="role === 'specialist' ? appointment[role][0].title : 'Client'"
      :specialistAvatar="appointment[role][0].image_url"
    />

    <TemplateCard
      v-else
      @clickSubAction="meetingCancel"

      :appearance="appearance"
      :highlight="false"

      cardActionType="primary"
      :cardActionValue="`Timp rămas: ${ timeRemaining }`"
      cardSubActionType="danger"
      :cardSubActionValue="appearance === 'list' ? 'Anulare' : 'Anulează programarea'"

      :cardList="[
        { icon: 'fa-clock'   , title: 'Durată programare', value: timeDuration },
        { icon: 'fa-calendar', title: 'Data'             , value: timeDate }
      ]"

      :specialistId="role === 'specialist' ? appointment.specialist_id : null"
      :spacialistName="appointment[role][0].full_name"
      :specialistTitle="role === 'specialist' ? appointment[role][0].title : 'Client'"
      :specialistAvatar="appointment[role][0].image_url"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import UiModal        from '@/components/ui/Modal';
import TemplateCard   from './TemplateCard';

export default {
  components: { UiModal, TemplateCard },
  props: [ 'appearance', 'appointment', 'skeleton' ],
  created() {
    setInterval(() => {
      if (!(this.appointment)) {
        return;
      }

      this._computedWatchers.timeStampEnd.run();
      this._computedWatchers.timeStampStart.run();

      this._computedWatchers.status.run();
      this._computedWatchers.timeDate.run();
      this._computedWatchers.timeDateTime.run();
      this._computedWatchers.timeDuration.run();
      this._computedWatchers.timeRemaining.run();
      this.$forceUpdate();
    }, 1000);
  },
  data() {
    return { cancelModal: false };
  },
  computed: {
    ...mapGetters({
      meetingStatus : 'meeting/status',
      widget        : 'layout/widget',
    }),

    role() {
      if (this.appointment.client !== undefined) {
        return 'client';
      }

      return 'specialist';
    },

    status() {
      if (Date.now() > this.timeStampEnd) {
        return 'ended';
      }

      if (Date.now() > this.timeStampStart) {
        if (this.meetingStatus === null) {
          return 'processing';
        }

        if (this.meetingStatus === 'processing') {
          return 'processing';
        }

        if (!(this.widget)) {
          return 'processing';
        }

        if (!(this.widget.specialist)) {
          return 'processing';
        }

        return 'started';
      }

      return 'confirmed';
    },

    timeDate() {
      const end   = this.$moment(this.timeStampEnd  ).format('HH:mm');
      const start = this.$moment(this.timeStampStart).format('HH:mm');

      const dayEnd   = this.$moment(this.timeStampEnd  ).format('dd');
      const dayStart = this.$moment(this.timeStampStart).format('dd');

      if(dayStart === dayEnd) {
        //return `${ dayStart } ${ start } - ${ end }`;
        return `${ dayStart } ${ start }`;
      }

      //return `${ dayStart } ${ start } - ${ dayEnd } ${ end }`;
      return `${ dayStart } ${ start }`;
    },

    timeDateTime() {
      return this.$moment(this.timeStampStart).format("MMMM Do YYYY, HH:mm");
    },

    timeDuration() {
      if(this.appointment.status == 'canceled')
        return 'Anulată';
        
      const difference = this.$moment(this.timeStampStart).diff(this.timeStampEnd) + (this.appointment.services_count * 5 * 60000); //5ms * 6000ms = 5min break time
      return this.$moment.duration(difference).humanize();
    },

    timeRemaining() {
      const difference = this.$moment().diff(this.$moment(this.timeStampStart));
      return this.$moment.duration(difference).humanize();
    },

    timeStampEnd() {
      return (new Date(this.appointment.end_timestamp)).getTime();
    },

    timeStampStart() {
      return (new Date(this.appointment.start_timestamp)).getTime();
    },
  },
  methods: {
    ...mapActions({
      cancelAppointment : 'appointments/cancelAppointment',
    }),

    confirmCancel() {
      this.cancelModal = false;
      this.cancelAppointment({ id: this.appointment.id });
    },

    meetingCancel() {
      this.cancelModal = true;
    },

    meetingJoin() {
      this.$emit('openJoinMeeting');
    },
  }
}
</script>

<style lang="scss" scoped>
.appointment-card {
  padding: 10px;

  &__warning {
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
    padding-bottom: 45px;
    padding-top: 30px;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.4;
  }
}
</style>
